/*
 * @Date: 2021-03-10 16:18:26
 * @author: yanhoup
 * @description: 分页组件
 */
import React from 'react';
import { Pagination } from '@fpxfd/next';
import { PaginationProps } from '@fpxfd/next/types/pagination';
import $i18n from 'panda-i18n';

const FpxPagination = (props: PaginationProps) => {
  return (
    <Pagination
      style={{ marginTop: 16, textAlign: 'right' }}
      pageSizeSelector="dropdown"
      showJump
      pageSizePosition="start"
      pageSizeList={[10, 20, 50, 100, 500]}
      data-i18n-ignore-content
      totalRender={(value) => (
        <span style={{ fontSize: '14px' }}>
          {$i18n.get({ id: 'TotalNumberOfEntries.four_px', dm: '总条数' })}:{value}
        </span>
      )}
      size="medium"
      {...props}
    />
  );
};

export default FpxPagination;
